import i18n from '../i18n';
import { apiGet, apiPost } from '../util/HttpApi';
import { BBOX_COORDS_DECIMALS } from './GlobalManager';
import { getCurrentTimeParams } from '../util/Utils';
import { getApiLang } from '../util/lang';

function formatBboxCorner(corner) {
    return `${Number(corner.lat).toFixed(BBOX_COORDS_DECIMALS)},${Number(corner.lng).toFixed(BBOX_COORDS_DECIMALS)}`;
}

export function getMapsFromUrl() {
    return new URLSearchParams(globalThis.location.search).get('maps') || null;
}

export function searchByWordApi({
    latlng,
    bbox,
    query,
    baseSearch = false,
    spatial = false,
    autocomplete = false,
    abortControllerKey = null,
    maps = null,
}) {
    return apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/search`, {
        apiCache: true,
        ...(abortControllerKey ? { abortControllerKey, abortOnCacheHit: true } : {}),
        params: {
            lat: latlng.lat,
            lon: latlng.lng,
            northWest: formatBboxCorner(bbox.getNorthWest()),
            southEast: formatBboxCorner(bbox.getSouthEast()),
            text: query,
            locale: getApiLang(i18n.language),
            baseSearch,
            ...(spatial ? { spatial: true } : {}),
            ...(autocomplete ? { autocomplete: true } : {}),
            ...(maps ? { maps } : {}),
        },
    });
}

export function getPoiByOsmIdApi({ lat, lon, osmid, type, signal }) {
    return apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-poi-by-osmid`, {
        apiCache: true,
        signal,
        params: { lat, lon, osmid, type },
    });
}

// POI of a vector tile object: id is the map object id of the tile feature, tags are used when it is not in the POI index
export function getPoiByMapObjectApi({ lat, lon, id, tags, signal }) {
    return apiPost(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-poi-by-map-object`, tags, {
        apiCache: true,
        signal,
        params: { lat, lon, id },
    });
}

export function getPoiApi({ pin, name, type, osmId, wikidataId, lang, signal }) {
    const params = { pin, name, type, osmId, wikidataId, lang };

    return apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-poi`, {
        apiCache: true,
        signal,
        params: Object.fromEntries(Object.entries(params).filter(([, value]) => value != null)),
    });
}

export function getOpeningHoursInfoApi({ openingHours, signal }) {
    return apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-opening-hours-info`, {
        apiCache: true,
        signal,
        params: { openingHours, ...getCurrentTimeParams(), minute: Math.floor(Date.now() / 60000) },
    });
}

export function getTransportStopApi({ lat, lon, stopId, signal }) {
    return apiGet(`${process.env.REACT_APP_ROUTING_API_SITE}/search/get-transport-stop`, {
        apiCache: true,
        signal,
        params: { lat, lon, stopId },
    });
}

export function searchUserDataApi({ query, openedTracks }) {
    return apiPost(`${process.env.REACT_APP_USER_API_SITE}/mapapi/search-user-data`, openedTracks, {
        params: { query },
        abortControllerKey: 'userDataSearch',
    });
}
